import { useState, useEffect } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { submitDrawing } from "@/utils/drawingSubmission";
import { SubmitForm } from "@/components/SubmitForm";
import { SubmissionConfetti } from "@/components/SubmissionConfetti";
import { AuthDialog } from "@/components/AuthDialog";


interface DrawingSubmissionHandlerProps {
  session: any;
  showSubmitForm: boolean;
  setShowSubmitForm: (show: boolean) => void;
  setIsDrawing: (isDrawing: boolean) => void;
  setHasDrawn: (hasDrawn: boolean) => void;
}

export const DrawingSubmissionHandler = ({
  session,
  showSubmitForm,
  setShowSubmitForm,
  setIsDrawing,
  setHasDrawn,
}: DrawingSubmissionHandlerProps) => {
  const [showConfetti, setShowConfetti] = useState(false);
  const [showAuthDialog, setShowAuthDialog] = useState(false);



  useEffect(() => {
    if (showConfetti) {
      const timer = setTimeout(() => {
        setShowConfetti(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showConfetti]);

  const handleSubmit = async (data: { name: string; email: string; newsletter: boolean }) => {
    try {
      console.log('Starting submission process with data:', { ...data, email: '***' });
      
      const canvas = document.querySelector('canvas');
      if (!canvas) {
        console.error('No canvas element found');
        toast.error("Versturen van tekening is mislukt");
        return;
      }

      // Submit the drawing
      console.log('Proceeding with drawing submission...');
      const fileName = await submitDrawing(canvas, session?.user?.id || null, data);
      
      if (!fileName) {
        console.error('No filename returned from submitDrawing');
        toast.error("Versturen van tekening is mislukt");
        return;
      }

      toast.success("Je hart is ingediend! Check je e-mail voor de verificatielink om het te publiceren.");

      setShowConfetti(true);
      setShowSubmitForm(false);
      setIsDrawing(false);
      setHasDrawn(false);
    } catch (error: any) {
      console.error('Error in handleSubmit:', error);
      if (error?.code === "EMAIL_VERIFIED_LOGIN_REQUIRED") {
        toast.error(error.message, {
          duration: 8000,
          action: {
            label: "Inloggen",
            onClick: () => setShowAuthDialog(true),
          },
        });
        return;
      }
      toast.error(error.message || "Versturen van tekening is mislukt");
    }
  };

  return (
    <>
      {showSubmitForm && (
        <SubmitForm onClose={() => setShowSubmitForm(false)} onSubmit={handleSubmit} />
      )}
      <SubmissionConfetti isActive={showConfetti} />
      {showAuthDialog && <AuthDialog onClose={() => setShowAuthDialog(false)} />}
    </>
  );
};
